(function () {
  const WARRANTY_PRODUCT_TYPE = "Warranty";
  const MESSAGE_TEXT = "Shipping protection must be purchased with another item.";

  function isCheckoutButton(el) {
    if (!el) return false;
    // Covers common cart page + cart drawer button patterns
    const isNameCheckout = el.name === "checkout";
    const isHrefCheckout = (el.getAttribute("href") || "").includes("/checkout");
    const isActionCheckout = (el.getAttribute("formaction") || "").includes("/checkout");
    const isCheckoutClass = (el.className || "").toLowerCase().includes("checkout");
    return isNameCheckout || isHrefCheckout || isActionCheckout || isCheckoutClass;
  }

  function findCheckoutButtons() {
    const candidates = Array.from(document.querySelectorAll("button, input[type='submit'], a"));
    return candidates.filter(isCheckoutButton);
  }

  function ensureMessageNear(btn) {
    if (!btn) return null;

    // If we've already added a message near this button, reuse it
    const existing = btn.parentElement && btn.parentElement.querySelector(".warranty-guard-message");
    if (existing) return existing;

    const msg = document.createElement("div");
    msg.className = "warranty-guard-message";
    msg.style.marginTop = "10px";
    msg.style.padding = "10px 12px";
    msg.style.border = "1px solid rgba(0,0,0,0.15)";
    msg.style.borderRadius = "8px";
    msg.style.fontSize = "14px";
    msg.style.lineHeight = "1.3";
    msg.style.display = "none";
    msg.textContent = MESSAGE_TEXT;

    // Put message right after the checkout button when possible
    if (btn.parentElement) {
      btn.parentElement.appendChild(msg);
    } else {
      document.body.appendChild(msg);
    }

    return msg;
  }

  function setCheckoutDisabled(disabled) {
    const buttons = findCheckoutButtons();
    buttons.forEach((btn) => {
      const msg = ensureMessageNear(btn);

      // Disable buttons and prevent clicks for <a>
      if (btn.tagName.toLowerCase() === "a") {
        if (disabled) {
          btn.setAttribute("aria-disabled", "true");
          btn.dataset.warrantyGuardHref = btn.getAttribute("href") || "";
          btn.removeAttribute("href");
          btn.style.pointerEvents = "none";
          btn.style.opacity = "0.5";
        } else {
          btn.setAttribute("aria-disabled", "false");
          if (btn.dataset.warrantyGuardHref) {
            btn.setAttribute("href", btn.dataset.warrantyGuardHref);
            delete btn.dataset.warrantyGuardHref;
          }
          btn.style.pointerEvents = "";
          btn.style.opacity = "";
        }
      } else {
        // button / input
        btn.disabled = !!disabled;
        btn.style.opacity = disabled ? "0.5" : "";
        btn.style.cursor = disabled ? "not-allowed" : "";
      }

      if (msg) msg.style.display = disabled ? "block" : "none";
    });
  }

  async function checkCartAndEnforce() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;

      const cart = await res.json();
      const items = cart.items || [];

      const onlyWarranty =
        items.length === 1 &&
        (items[0].product_type || "") === WARRANTY_PRODUCT_TYPE;

      setCheckoutDisabled(onlyWarranty);
    } catch (e) {
      // Fail open (don't block checkout) if something unexpected happens
      setCheckoutDisabled(false);
    }
  }

  function startWatching() {
    // Run now
    checkCartAndEnforce();

    // Re-run after common cart update events (some themes dispatch these)
    document.addEventListener("cart:updated", checkCartAndEnforce);
    document.addEventListener("cart:refresh", checkCartAndEnforce);

    // Watch DOM changes (covers cart drawer Ajax updates)
    const observer = new MutationObserver(() => {
      // Debounce-ish: do a quick check; cart.js is fast
      checkCartAndEnforce();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    // Also re-check when the drawer opens, etc.
    window.addEventListener("focus", checkCartAndEnforce);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startWatching);
  } else {
    startWatching();
  }
})();